import {Component, Input} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

declare let window:any;

const SOCIAL_SITES = [{
  name: 'twitter',
  url: (url, message) => `https://twitter.com/intent/tweet?url=${url}&text=${message}`,
}, {
  name: 'facebook',
  url: (url, message) => `http://www.facebook.com/sharer.php?u=${url}`,
}, {
  name: 'google-plus',
  url: (url, message) => `https://plus.google.com/share?url=${url}`,
}, {
  name: 'hacker-news',
  url: (url, message) => `https://news.ycombinator.com/submitlink?u=${url}&t=${message}`,
}];

@Component({
    selector: 'social-buttons',
    templateUrl: '../views/social-buttons.pug',
})
export class SocialButtonsComponent {
  @Input() url;
  @Input() message;
  sites:any = SOCIAL_SITES;
  constructor(private sanitizer:DomSanitizer) {}

  getLink(site):SafeUrl {
    let url = this.url || window.location.href;
    if (url.indexOf(';') !== -1) {
      url = url.substring(0, url.indexOf(';'));
    }
    let link = site.url(encodeURIComponent(url), encodeURIComponent(this.message));
    return this.sanitizer.bypassSecurityTrustUrl(link);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/social-buttons.ts